export const parentContainerStyles = {
  padding: 24,
  backgroundColor: "var(--primary)",
};

export const mintContainerStyles = {
  backgroundColor: "var(--accent)",
  // padding: 24,
  // borderRadius: 24,
  // border: "4px dashed var(--secondary)",
  // boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
  padding: "1.3rem",
  borderRadius: 3,
  boxShadow: "0 2px 20px #E2C044",
};

export const countTitleStyles = {
  textAlign: "center",
  fontSize: 50,
  fontWeight: "bold",
  color: "#e9d8a6",
};

export const contractAddressDescStyles = {
  textAlign: "center",
  color: "var(--primary-text)",
};

export const nftCostTitleStyles = {
  textAlign: "center",
  color: "var(--accent-text)",
};

export const normalTextStyles = {
  textAlign: "center",
  color: "var(--accent-text)",
};
